import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";

const AutoLogin = ({ setIsAuthenticated }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const Empcode = urlParams.get("EmpCode");
        const Boardroom_Password = urlParams.get("Password"); // Value from URL

        if (Empcode && Boardroom_Password) {
            handleAutoLogin(Empcode, Boardroom_Password);
        }
    }, []);

    const handleAutoLogin = async (Empcode, Boardroom_Password) => {
        try {
            const response = await axios.get(`${config.API_BASE_URL}/login`, {
                params: { Empcode, Password: Boardroom_Password },
            });

            if (response.data.UserLoggedIn) {
                localStorage.setItem("userLoggedIn", "true");
                localStorage.setItem("Empcode", response.data.Empcode);
                localStorage.setItem("Boardroom_AccessLevel", response.data.Boardroom_AccessLevel);
                localStorage.setItem("EmployeeName", response.data.EmployeeName);

                setIsAuthenticated(true);
                navigate("/dashboard"); // Redirect to Dashboard
            } else {
                console.error("Invalid credentials");
            }
        } catch (error) {
            console.error("❌ Auto-login error:", error);
        }
    };

    return null;
};

export default AutoLogin;
